import { message } from 'antd';

export default () => next => async (action) => {
  if (!action.promise) {
    return next(action);
  }
  next({
    ...action,
    type: action.type.PENDING
  });
  let data;
  try {
    const resp = await action.promise;
    data = resp.data;
    if (action.success) {
      message.success(action.success);
    }
  } catch (error) {
    if (action.error) {
      message.error(action.error);
    }
    message.error(error.message, 5);
    next({ ...action, type: action.type.REJECTED, error });
    throw error;
  }
  next({ ...action, type: action.type.RESOLVED, data });
  return data;
};



// WEBPACK FOOTER //
// ./src/utils/middlewares/promiseMiddleware.js